module.exports = __webpack_public_path__ + "assets/img/connections.e23459e7.svg";